import useBundleTranslation from 'i18n';
import { FormControlCheckboxProps } from 'components/common/form/layout/control';
import { FormRendererAPIType } from 'components/common/form';
import React from 'react';
import FormCheckbox from 'components/common/form/layout/control/FormCheckbox';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';

export default function CheckBoxHeader({
    name,
    label,
    checked,
    onChange,
}: {
    name: string;
    label: string;
    checked: boolean;
    onChange: any;
}) {
    const { t } = useBundleTranslation(['components/common/check_box_list']);
    const headerCheckBox: FormControlCheckboxProps = {
        form: {} as FormRendererAPIType,
        name: '__bulk_change_' + name,
        label: label,
        onChange: onChange,
        checked: checked,
    };
    return (
        <Box
            sx={{
                backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.06),
                color: (theme) => alpha(theme.palette.text.primary, 0.64),
                py: 0.25,
                px: 1,
                borderRadius: 1,
            }}
        >
            <FormCheckbox controlProps={headerCheckBox} />
        </Box>
    );
}
